import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
import { usePermission } from "../../../utils/commonfunction";
import logo from "../../../assets/admin/img/logo.svg";
import shortLogo from "../../../assets/admin/img/logos/short-logo.png";
import { useTranslation } from "react-i18next";
import { TrimText } from "../../../utils/commonfunction";
import * as inquiriesService from "../services/inquiry.services";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();
  const { can, isSuperAdmin } = usePermission();
  const [newInquiryCount, setNewInquiryCount] = useState(0);

  const fetchNewInquiryCount = () => {
    if (can("/admin/inquiries/list")) {
      inquiriesService
        .GetNewCount()
        .then((res) => {
          if (res?.data?.count !== undefined) {
            setNewInquiryCount(res.data.count);
          }
        })
        .catch(() => {});
    }
  };

  useEffect(() => {
    fetchNewInquiryCount();
    window.addEventListener("inquiryStatusUpdated", fetchNewInquiryCount);
    return () => {
      window.removeEventListener("inquiryStatusUpdated", fetchNewInquiryCount);
    };
  }, [loc.pathname]);

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    dropDown.classList.toggle("show");
  };

  const hoverSidebar = () => {
    if ($("body").hasClass("main-sidebar-hide")) $("body").addClass("main-sidebar-open");
    else $("body").removeClass("main-sidebar-open");
  };

  const removeHoverSidebar = () => $("body").removeClass("main-sidebar-open");

  return (
    <div className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y" id="app_sidebar"
      onMouseEnter={hoverSidebar} onMouseLeave={removeHoverSidebar}>
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img src={shortLogo} className="header-brand-img icon-logo" alt="logo"
            style={{ height: "37px", width: "auto", marginTop: "6px", marginBottom: "6px" }} id="logo_short" />
          <img src={logo} className="header-brand-img desktop-logo rounded"
            style={{ height: "4rem", width: "auto" }} alt="logo" id="logo_full" />
        </a>
      </div>

      <div className="main-sidebar-body">
        <ul className="nav">

          {/* Dashboard */}
          {can("/admin/dashboard") && (
            <li className={"nav-item" + (loc.pathname === "/admin/dashboard" ? " active" : "")}>
              <Link className="nav-link" to="/admin/dashboard">
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fa fa-home sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_dashboard")}</span>
              </Link>
            </li>
          )}

          {/* CMS */}
          {(can("/admin/cms/pages/list") || can("/admin/cms/banner/list") ||
            can("/admin/cms/default-email-template/list") || can("/admin/cms/settings") ||
            can("/admin/cms/faq-management/faq/list") || can("/admin/cms/subjects/list")) && (
            <li className={`nav-item ` + (loc.pathname.includes("/cms") ? "show active" : "")}>
              <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fa fa-cogs sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                {can("/admin/cms/pages/list") && (
                  <li className={`nav-sub-item ${loc.pathname.includes("/cms/pages") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`/admin/cms/pages/list/1`}>{t("sidebar_link_pages")}</Link>
                  </li>
                )}
                {can("/admin/cms/banner/list") && (
                  <li className={`nav-sub-item ${loc.pathname.includes("/cms/banner") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`/admin/cms/banner/list/1`}>{t("sidebar_link_banners")}</Link>
                  </li>
                )}
                {can("/admin/cms/default-email-template/list") && (
                  <li className={"nav-sub-item" + (loc.pathname.includes("/cms/default-email-template") ? " active" : "")}>
                    <Link className="nav-sub-link" to={`/admin/cms/default-email-template/list/1`}>{t("sidebar_link_email_template")}</Link>
                  </li>
                )}
                {can("/admin/cms/settings") && (
                  <li className={"nav-sub-item" + (loc.pathname.includes("/cms/settings") ? " active" : "")}>
                    <Link className="nav-sub-link" to={`/admin/cms/settings`}>{t("sidebar_link_global_settings")}</Link>
                  </li>
                )}
                {(can("/admin/cms/web-app") || can("/admin/cms/settings")) && (
                  <li className={"nav-sub-item" + (loc.pathname.includes("/cms/web-app") ? " active" : "")}>
                    <Link className="nav-sub-link" to={`/admin/cms/web-app`}>Web App Settings</Link>
                  </li>
                )}
                {can("/admin/cms/faq-management/faq/list") && (
                  <li className={`nav-sub-item ` + (loc.pathname.includes("/cms/faq-management") ? "show active" : "")}>
                    <Link className="nav-sub-link" to={`/admin/cms/faq-management/faq/list/1`}>{t("sidebar_link_faq")}</Link>
                  </li>
                )}
                {can("/admin/cms/subjects/list") && (
                  <li className={`nav-sub-item ` + (loc.pathname.includes("/cms/subjects") ? "active" : "")}>
                    <Link className="nav-sub-link" to={`/admin/cms/subjects/list/1`}>Subjects</Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {/* Streamers */}
          {can("/admin/streamers/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/streamers/") || loc.pathname.includes("/customers/") ? "show active" : "")}>
              <Link className="nav-link" to={`/admin/streamers/list/1`}>
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fa fa-user sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_streamers")}</span>
              </Link>
            </li>
          )}

           {/* Sub Admin Management — super admin only */}
          {isSuperAdmin && (
            <li className={`nav-item ` + (loc.pathname.includes("/staff") || loc.pathname.includes("/role") ? "show active" : "")}>
              <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fa fa-user-shield sidemenu-icon"></i>
                <span className="sidemenu-label">Sub Admin</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                <li className={`nav-sub-item ${loc.pathname.includes("/staff/") ? " active" : ""}`}>
                  <Link className="nav-sub-link" to={`/admin/staff/list/1`}>Sub Admins</Link>
                </li>
                <li className={`nav-sub-item ${loc.pathname.includes("/role/") ? " active" : ""}`}>
                  <Link className="nav-sub-link" to={`/admin/role/list/1`}>Roles</Link>
                </li>
              </ul>
            </li>
          )}


          {/* Package Management */}
          {can("/admin/packageManagement/packages/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/packageManagement") ? "show active" : "")}>
              <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fa fa-cogs sidemenu-icon"></i>
                <span className="sidemenu-label">{TrimText(t("packageManagement_link"), 14)}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                <li className={`nav-sub-item ${loc.pathname.includes("packageManagement/packages") ? " active" : ""}`}>
                  <Link className="nav-sub-link" to={`packageManagement/packages/list/1`}>{t("packages")}</Link>
                </li>
              </ul>
            </li>
          )}

          {/* Product Management */}
          {(can("/admin/productManagement/products/list") || can("/admin/productManagement/categories/list")) && (
            <li className={`nav-item ` + (loc.pathname.includes("/productManagement") ? "show active" : "")}>
              <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fa fa-cogs sidemenu-icon"></i>
                <span className="sidemenu-label">{TrimText(t("productManagement_link"), 14)}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              {can("/admin/productManagement/categories/list") && (
                <ul className="nav-sub">
                  <li className={`nav-sub-item ${loc.pathname.includes("productManagement/groupings") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`productManagement/groupings/list/1`}>Attributes Grouping</Link>
                  </li>
                  <li className={`nav-sub-item ${loc.pathname.includes("productManagement/categories") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`productManagement/categories/list/1`}>{t("categories")}</Link>
                  </li>
                  <li className={`nav-sub-item ${loc.pathname.includes("productManagement/subcategories") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`productManagement/subcategories/list/1`}>{t("sub_categories")}</Link>
                  </li>
                  <li className={`nav-sub-item ${loc.pathname.includes("productManagement/presubcategories") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`productManagement/presubcategories/list/1`}>{t("pre_sub_categories")}</Link>
                  </li>
                  <li className={`nav-sub-item ${loc.pathname.includes("productManagement/attributes") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`productManagement/attributes/list/1`}>{t("Attributes")}</Link>
                  </li>
                  <li className={`nav-sub-item ${loc.pathname.includes("productManagement/colors") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`productManagement/colors/list/1`}>{t("Colors")}</Link>
                  </li>
                </ul>
              )}
              {can("/admin/productManagement/products/list") && (
                <ul className="nav-sub">
                  <li className={`nav-sub-item ${loc.pathname.includes("productManagement/products") ? " active" : ""}`}>
                    <Link className="nav-sub-link" to={`productManagement/products/list/1`}>{t("product")}</Link>
                  </li>
                </ul>
              )}
            </li>
          )}

          {/* Stream */}
          {can("/admin/stream/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/stream/") ? "show active" : "")}>
              <Link className="nav-link" to={`/admin/stream/list/1`}>
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fas fa-video sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_stream")}</span>
              </Link>
            </li>
          )}

          {/* Leads */}
          {can("/admin/leads/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/leads/") ? "show active" : "")}>
              <Link className="nav-link" to={`/admin/leads/list/1`}>
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fas fa-user-friends sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_leads")}</span>
              </Link>
            </li>
          )}

          {/* Payment */}
          {can("/admin/payment/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/payment") ? "show active" : "")}>
              <Link className="nav-link" to={`/admin/payment/list/1`}>
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fas fa-credit-card sidemenu-icon"></i>
                <span className="sidemenu-label">{t("Transactions")}</span>
              </Link>
            </li>
          )}

          {/* Reports */}
          {(can("/admin/reports/productReport/list") || can("/admin/reports/customers/list") ||
            can("/admin/reports/stream/list") || can("/admin/reports/packageReport/list")) && (
            <li className={`nav-item ${loc.pathname.includes("/reports/") ? "show active" : ""}`}>
              <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fa fa-clipboard sidemenu-icon"></i>
                <span className="sidemenu-label">{TrimText(t("Reports"), 14)}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                {can("/admin/reports/productReport/list") && (
                  <li className={`nav-sub-item ${loc.pathname.includes("reports/productReport") ? "active" : ""}`}>
                    <Link className="nav-sub-link" to={`reports/productReport/list/1`}>{t("products_report")}</Link>
                  </li>
                )}
                {can("/admin/reports/customers/list") && (
                  <li className={`nav-sub-item ${loc.pathname.includes("reports/customers") ? "active" : ""}`}>
                    <Link className="nav-sub-link" to={`reports/customers/list/1`}>{t("customers_report")}</Link>
                  </li>
                )}
                {can("/admin/reports/stream/list") && (
                  <li className={`nav-sub-item ${loc.pathname.includes("reports/stream") ? "active" : ""}`}>
                    <Link className="nav-sub-link" to={`reports/stream/list/1`}>{t("streams_report")}</Link>
                  </li>
                )}
                {can("/admin/reports/packageReport/list") && (
                  <li className={`nav-sub-item ${loc.pathname.includes("reports/packageReport") ? "active" : ""}`}>
                    <Link className="nav-sub-link" to={`reports/packageReport/list/1`}>{t("packages_revenue_report", "Packages Report")}</Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {/* Inquiries */}
          {can("/admin/inquiries/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/inquiries") ? "show active" : "")} style={{ position: "relative" }}>
              <Link className="nav-link" to={`/admin/inquiries/list/1`}>
                <span className="shape1"></span><span className="shape2"></span>
                <i className="fas fa-question-circle sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_inquiries")}</span>
                {newInquiryCount > 0 && (
                  <span
                    className="badge bg-warning text-dark side-badge"
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "22px",
                      transform: "translateY(-50%)",
                      minWidth: "22px",
                      height: "22px",
                      width: newInquiryCount > 9 ? "auto" : "22px",
                      borderRadius: newInquiryCount > 9 ? "11px" : "50%",
                      padding: newInquiryCount > 9 ? "0 6px" : "0",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "700",
                      fontSize: "11px",
                      lineHeight: "1",
                      boxSizing: "border-box",
                    }}
                  >
                    {newInquiryCount}
                  </span>
                )}
              </Link>
            </li>
          )}

         
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
